module.exports = __webpack_public_path__ + "img/yuan-no.960f74cc.svg";